import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, group: String }

  share(event) {
    event.preventDefault()

    if (navigator.share) {
      navigator.share({ url: this.urlValue })
    } else {
      navigator.clipboard.writeText(this.urlValue).then(() => {
        this.showToast()
        window.open(this.groupValue, "_blank")
      })
    }
  }

  showToast() {
    const toast = document.createElement("div")
    toast.textContent = "Link copied! Paste it in your post."
    toast.style.cssText = "position:fixed;bottom:5rem;left:50%;transform:translateX(-50%);background:#292524;color:#fff;padding:0.75rem 1.5rem;border-radius:0.5rem;font-size:0.875rem;z-index:9999;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s"
    document.body.appendChild(toast)
    setTimeout(() => {
      toast.style.opacity = "0"
      setTimeout(() => toast.remove(), 300)
    }, 4000)
  }
}
